import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import RouteIslandCard from "site-apps/distribution/route/RouteIslandCard";
import RouteWaypointCard from "site-apps/distribution/route/RouteWaypointCard";
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";

const FormRouteIslandsList = ({waypoints, highlighted, setHighligthed, wasteType}) => {
    const {t: _CT} = useCustomTranslation(translations);

    // un clic resalta el punto en el mapa; otro clic en el mismo lo quita
    const eyeColumn = (_asset) => (
        <div className="col p-0" style={{maxWidth: "29px"}}>
            <button
                type="button"
                className={`btn btn-link ${highlighted === _asset.id ? "text-primary" : "text-body-tertiary"}`}
                title={_CT("show-on-map")}
                onClick={() => setHighligthed(highlighted === _asset.id ? null : _asset.id)}>
                <FontAwesomeIcon icon="eye" size="lg" />
            </button>
        </div>
    );

    return (
        <ul className="list-unstyled">
            {waypoints.map((_asset, index) => {
                if (_asset.is_asset) {
                    return (
                        <li className="row" key={"prov-ass-" + index}>
                            <div className="col border rounded p-2 mb-3 bg-white">
                                <RouteIslandCard asset={_asset} key={"card-asset-" + index} wasteType={wasteType} />
                            </div>
                            {eyeColumn(_asset)}
                        </li>
                    );
                } else if (_asset.mooch) {
                    return (
                        <li className="row" key={"prov-moo-" + index}>
                            <div className="col border rounded p-2 mb-3 bg-white">
                                <RouteIslandCard asset={_asset} key={"card-mooch-" + index} wasteType={"fl"} />
                            </div>
                            {eyeColumn(_asset)}
                        </li>
                    );
                } else {
                    return (
                        <li className="row" key={"prov-way-" + index}>
                            <div className="col border rounded p-2 mb-3 bg-white">
                                <RouteWaypointCard routeway={_asset} key={"card-way-" + index} />
                            </div>
                            {eyeColumn(_asset)}
                        </li>
                    );
                }
            })}
        </ul>
    );
};
export default FormRouteIslandsList;
